import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "InfoList" }
const _hoisted_3 = { class: "topAmount" }
const _hoisted_4 = { class: "inputLabel" }
const _hoisted_5 = { class: "inputLabel" }
const _hoisted_6 = { class: "tabList" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "input_field"
}
const _hoisted_9 = {
  key: 1,
  class: "input_field"
}
const _hoisted_10 = {
  key: 2,
  class: "input_field"
}
const _hoisted_11 = {
  key: 3,
  class: "input_field"
}
const _hoisted_12 = {
  key: 4,
  class: "errorText"
}
const _hoisted_13 = { class: "input_field" }
const _hoisted_14 = { class: "inputLabel" }
const _hoisted_15 = { class: "input_field" }
const _hoisted_16 = {
  key: 5,
  class: "errorText"
}
const _hoisted_17 = {
  key: 6,
  class: "input_field"
}
const _hoisted_18 = { class: "inputLabel" }
const _hoisted_19 = {
  key: 7,
  class: "input_field"
}
const _hoisted_20 = { class: "inputLabel" }
const _hoisted_21 = { class: "btn_container" }

import { ref, watch, computed } from 'vue'
import CustomHeader from '../components/common/customHeader.vue';
import { useI18n } from 'vue-i18n';
import MainButton from '../components/common/mainButton.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { TAB_TYPE_LIST, WithdrawPopupData } from '@/view/withdraw/supportScript';
import { useWithdrawStore } from '@/stores/withdraw';

export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawPopup',
  props: {
    dataSet: {}
  },
  emits: ['close', 'open', 'selectTabType', 'confirmWithdraw', 'checkFieldsFill', 'update:dataSet', 'changeValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const withdrawStore = useWithdrawStore()

const props = __props

const show = ref(props.dataSet.show)
const cpfID = ref(props.dataSet.cpfID)
const emailID = ref(props.dataSet.emailID)
const phoneID = ref(props.dataSet.phoneID)
const evpID = ref(props.dataSet.evpID)
const userName = ref(props.dataSet.userName)
const cpfNumber = ref(props.dataSet.cpfNumber)
const brazilID = ref(props.dataSet.brazilID)
const bank = ref(props.dataSet.bank)
const showCPFIdError = ref(props.dataSet.showCPFIdError)
const showEmaiIdError = ref(props.dataSet.showEmaiIdError)
const showPhoneIdError = ref(props.dataSet.showPhoneIdError)
const showEvpIdError = ref(props.dataSet.showEvpIdError)
const showCPFNumError = ref(props.dataSet.showCPFNumError)
const activeButton = ref(false)

const emits = __emit

const open = (amount: number, data: any) => {
    emits('open')
}
const close = () => {
    emits('close')
}

const selectTabType = (item: any) => {
    emits('selectTabType', item)
}

const confirmWithdraw = () => {
    emits('confirmWithdraw')
}

// const checkFieldsFill = () => {
//     emits('checkFieldsFill')
// }
watch(() => props.dataSet, (newVal) => {
    cpfID.value = newVal.cpfID
    emailID.value = newVal.emailID
    phoneID.value = newVal.phoneID
    evpID.value = newVal.evpID
    userName.value = newVal.userName
    cpfNumber.value = newVal.cpfNumber
    brazilID.value = newVal.brazilID
    bank.value = newVal.bank
}, { deep: true, immediate: true })

watch(cpfID, (val) => {
    if (val.length == 11) {
        showCPFIdError.value = false
    } else {
        showCPFIdError.value = true
    }
    let data = {
        type: 'cpfID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(emailID, (val) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(val)) {
        showEmaiIdError.value = false
    } else {
        showEmaiIdError.value = true
    }
    let data = {
        type: 'emailID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(phoneID, (val) => {
    if (val.length == 11) {
        showPhoneIdError.value = false
    } else {
        showPhoneIdError.value = true
    }
    let data = {
        type: 'phoneID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(evpID, (val) => {
    if (val.length > 0) {
        showEvpIdError.value = false
    } else {
        showEvpIdError.value = true
    }
    let data = {
        type: 'evpID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(cpfNumber, (val) => {
    const value = String(val ?? '')

    if (value.length > 0 && value.length !== 11) {
        showCPFNumError.value = true
    } else {
        showCPFNumError.value = false
    }
    const data = {
        type: 'cpfNumber',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})

watch(userName, (val) => {
    let data = {
        type: 'userName',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(brazilID, (val) => {
    let data = {
        type: 'brazilID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(bank, (val) => {
    let data = {
        type: 'bank',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
const checkFieldsFill = () => {
    const activeId = props.dataSet.activeTab?.id

    if (activeId === 1) {
        activeButton.value = (cpfID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showCPFIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 2) {
        activeButton.value = (emailID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEmaiIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 3) {
        activeButton.value = (phoneID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showPhoneIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 4) {
        activeButton.value = (evpID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEvpIdError.value &&
            !showCPFNumError.value
    }
}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: _ctx.$t('common.sake'),
          isPopupCloseBackIcon: true,
          onClosePopup: close
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('withdraw.valueText')), 1),
            _createVNode(_component_van_row, { class: "amountRow" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "2",
                  class: "left_icon"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("R$")
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "22",
                  class: "amount"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("withdraw.value")) + " " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.selectedAmount)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('withdraw.taxIdType')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAB_TYPE_LIST), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tab_card", _ctx.dataSet?.activeTab.id == item.id ? 'active_tab' : '']),
                key: item.id,
                onClick: ($event: any) => (selectTabType(item))
              }, _toDisplayString(item.name), 11, _hoisted_7))
            }), 128))
          ]),
          (_ctx.dataSet?.activeTab.id == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "inputLabel" }, "CPF ID", -1)),
                _createVNode(_component_van_field, {
                  modelValue: cpfID.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cpfID).value = $event)),
                  type: "number",
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.cpf != null && _unref(withdrawStore).withdrawInfo.cpf != '',
                  placeholder: _ctx.$t('withdraw.cpfIdPlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "credit-pay" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.activeTab.id == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "inputLabel" }, "Email ID", -1)),
                _createVNode(_component_van_field, {
                  modelValue: emailID.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailID).value = $event)),
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.email != null && _unref(withdrawStore).withdrawInfo.email != '',
                  placeholder: _ctx.$t('withdraw.emailPlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "credit-pay" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.activeTab.id == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "inputLabel" }, "PHONE ID", -1)),
                _createVNode(_component_van_field, {
                  modelValue: phoneID.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneID).value = $event)),
                  type: "number",
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.phone != null && _unref(withdrawStore).withdrawInfo.phone != '',
                  placeholder: _ctx.$t('withdraw.phonePlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "credit-pay" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.activeTab.id == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "inputLabel" }, "EVP", -1)),
                _createVNode(_component_van_field, {
                  modelValue: evpID.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((evpID).value = $event)),
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.evpId != null && _unref(withdrawStore).withdrawInfo.evpId != '',
                  placeholder: _ctx.$t('withdraw.evpPlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "credit-pay" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.activeTab.id == 1 && showCPFIdError.value
                    || _ctx.dataSet?.activeTab.id == 2 && showEmaiIdError.value
                    || _ctx.dataSet?.activeTab.id == 3 && showPhoneIdError.value
                    || _ctx.dataSet?.activeTab.id == 4 && showEvpIdError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)(_ctx.dataSet?.activeTab.errorText)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('withdraw.userName')), 1),
            _createVNode(_component_van_field, {
              modelValue: userName.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userName).value = $event)),
              disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.userName != null && _unref(withdrawStore).withdrawInfo.userName != '',
              placeholder: _ctx.$t('withdraw.userNamePlaceholder')
            }, {
              "right-icon": _withCtx(() => [
                _createVNode(_component_van_icon, { name: "contact" })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "inputLabel" }, "CPF", -1)),
            _createVNode(_component_van_field, {
              modelValue: cpfNumber.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cpfNumber).value = $event)),
              type: "number",
              disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.cpfId != null && _unref(withdrawStore).withdrawInfo.cpfId != '',
              placeholder: _ctx.$t('withdraw.userNamePlaceholder')
            }, {
              "right-icon": _withCtx(() => [
                _createVNode(_component_van_icon, { name: "credit-pay" })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]),
          (showCPFNumError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("withdraw.cpfErrorText")), 1))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.selectedChannel.name == 'uupay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("withdraw.brazilId")), 1),
                _createVNode(_component_van_field, {
                  modelValue: brazilID.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((brazilID).value = $event)),
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.brazilId != null && _unref(withdrawStore).withdrawInfo.brazilId != '',
                  type: "number",
                  placeholder: _ctx.$t('withdraw.brazilIdPlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "contact" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataSet?.selectedChannel.name == 'winwinpay')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("withdraw.bank")), 1),
                _createVNode(_component_van_field, {
                  modelValue: bank.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bank).value = $event)),
                  disabled: _ctx.dataSet?.isDisabled && _unref(withdrawStore).withdrawInfo.bank != null && _unref(withdrawStore).withdrawInfo.bank != '',
                  type: "text",
                  placeholder: _ctx.$t('withdraw.bankPlaceholder')
                }, {
                  "right-icon": _withCtx(() => [
                    _createVNode(_component_van_icon, { name: "shop-o" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(MainButton, {
            title: _ctx.$t('common.sake'),
            activeStatus: activeButton.value,
            onClick: confirmWithdraw
          }, null, 8, ["title", "activeStatus"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})